import EditViewWrapper from './EditViewWrapper'

export default EditViewWrapper
